import React from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'


const BioinformaticsPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const categories = [
    { title: t('bioinformatics.categories.transcriptomics.title'), desc: t('bioinformatics.categories.transcriptomics.desc'), path: '/service/bioinformatics/transcriptomics', icon: 'genetics' },
    { title: t('bioinformatics.categories.epigenomics.title'), desc: t('bioinformatics.categories.epigenomics.desc'), path: '/service/bioinformatics/epigenomics', icon: 'schema' },
    { title: t('bioinformatics.categories.massSpec.title'), desc: t('bioinformatics.categories.massSpec.desc'), path: '/service/bioinformatics/mass-spectrometry', icon: 'labs' },
    { title: t('bioinformatics.categories.microbiome.title'), desc: t('bioinformatics.categories.microbiome.desc'), path: '/service/bioinformatics/microbiome', icon: 'microbiology' },
    { title: t('bioinformatics.categories.genomics.title'), desc: t('bioinformatics.categories.genomics.desc'), path: '/service/bioinformatics/genomics', icon: 'genetics' },
    { title: t('bioinformatics.categories.singleCell.title'), desc: t('bioinformatics.categories.singleCell.desc'), path: '/service/bioinformatics/single-cell', icon: 'cell_tower' },
    { title: t('bioinformatics.categories.spatialOmics.title'), desc: t('bioinformatics.categories.spatialOmics.desc'), path: '/service/bioinformatics/spatial-omics', icon: 'map' },
    { title: t('bioinformatics.categories.multiOmics.title'), desc: t('bioinformatics.categories.multiOmics.desc'), path: '/service/bioinformatics/multi-omics', icon: 'hub' },
    { title: t('bioinformatics.categories.publicData.title'), desc: t('bioinformatics.categories.publicData.desc'), path: '/service/bioinformatics/public-data-mining', icon: 'database' },
    { title: t('bioinformatics.categories.pipeline.title'), desc: t('bioinformatics.categories.pipeline.desc'), path: '/service/bioinformatics/pipeline-development', icon: 'developer_board' }
  ]

  const features = t('bioinformatics.features', { returnObjects: true })

  return (
    <ServiceLayout
      breadcrumbs={[
        { label: t('header.home'), path: '/' },
        { label: t('header.service'), path: '/service' },
        { label: t('bioinformatics.title') }
      ]}
      title={t('bioinformatics.title')}
      subtitle={t('bioinformatics.subtitle')}
    >
      {/* Key Features */}
      <div className="-mt-6 mb-12">
        <p className="text-text-muted mb-6">
          {t('bioinformatics.intro.p1')}
        </p>
        <p className="font-semibold text-text-main mb-4">{t('bioinformatics.intro.p2')}</p>
        <div className="space-y-4">
          {Array.isArray(features) && features.map((feature, index) => (
            <div key={index} className="bio-card-static rounded-xl p-6 border border-border-light">
              <h3 className="font-bold text-sm mb-2">{feature.title}</h3>
              <p className="text-text-muted text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Service Categories Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {categories.map((cat, index) => (
          <button
            key={index}
            onClick={() => navigate(cat.path)}
            className="group flex items-center gap-4 p-5 bio-card-static rounded-xl border border-border-light hover:border-primary/30 hover:bg-primary-50 transition-all text-left"
          >
            <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors flex-shrink-0">
              <span className="material-symbols-outlined">{cat.icon}</span>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-bold text-sm mb-2">{cat.title}</h3>
              <div className="flex flex-wrap gap-1.5">
                {cat.desc.split(/[、,　]+/).map((item, i) => item.trim() && (
                  <span key={i} className="px-2 py-1 rounded-md bg-surface-100 text-text-muted text-[10px] font-medium border border-border-light leading-none">
                    {item.trim()}
                  </span>
                ))}
              </div>
            </div>
            <ArrowRight className="w-4 h-4 text-text-muted group-hover:text-primary transition-colors flex-shrink-0" />
          </button>
        ))}
      </div>
    </ServiceLayout>
  )
}

export default BioinformaticsPage
